import { render, staticRenderFns } from "./IntroductionKeywordFrequency.vue?vue&type=template&id=706758b3&"
import script from "./IntroductionKeywordFrequency.vue?vue&type=script&lang=js&"
export * from "./IntroductionKeywordFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports